/*
 * Photo slots for the free-event surfaces (design pick 7A: fal.ai-generated
 * guest photos, delivered by Morty, movebooth-growth aa963d3). Each slot is a
 * 900 × 1200 sRGB JPG in public/free-start/. They are generated people: never
 * caption or describe them as real guests or real event photos, and keep
 * their alt text neutral (they are decorative here, so alt="").
 *
 * Slot → where it shows:
 *  guest-pair   /start ticket, print 1
 *  guest-solo-a /start ticket, print 2; limited dashboard, print 1
 *  guest-solo-b /start ticket, print 3; first run "What your guests get" 3; restore, print 1
 *  guest-hero   first run card photo (the tone call)
 *  guest-group  first run "What your guests get" 1; limited dashboard, print 3
 *  guest-solo-c first run "What your guests get" 2; restore, print 2
 *  guest-solo-d limited dashboard, print 2; restore, print 3
 */
const slot = (name) => `/free-start/${name}.jpg`;

export const PHOTOS = {
  "guest-pair": slot("guest-pair"),
  "guest-solo-a": slot("guest-solo-a"),
  "guest-solo-b": slot("guest-solo-b"),
  "guest-hero": slot("guest-hero"),
  "guest-group": slot("guest-group"),
  "guest-solo-c": slot("guest-solo-c"),
  "guest-solo-d": slot("guest-solo-d"),
};

// guest-solo-b's face sits right of center by design; crops keep it in frame.
export const PHOTO_POSITION = { "guest-solo-b": "85% 35%" };

export const photoSrc = (name) => PHOTOS[name] || null;
